<template>
  <div class="spBox">
    <div :style="{ maxWidth: width + 'px', overflow: 'hidden'}">
      <div class="swiper-top-container exhibitionSpecialBody">
        <div class="swiper-wrapper">
          <div class="swiper-slide exhibitionSpecialLink"
            v-for="special of specialExhibitions"
            :key="special.id"
          >
            <div class="exhibitionSpecialLinkInner">
              <p class="subTxt">Special Exhibition</p>
              <img class="linkImg" :src="smallLogo(special.logoUrl)" alt="" />
              <h3>{{special.name}}</h3>
              <p class="txt">{{cutText(special.description)}}</p>
            </div>
            <router-link class="StandardBtn linkBtn" :to="`/specials/${special.id}`">特別展示を見る</router-link>
          </div>
        </div>
      </div>
    </div>
    <a class="swiper-button-prev arrow_left"><img class="" src="/img/top_sp_arrow_left.png"
        srcset="/img/top_sp_arrow_left@2x.png 2x" alt="前へ" /></a>
    <a class="swiper-button-next arrow_right"><img class="" src="/img/top_sp_arrow_right.png"
        srcset="/img/top_sp_arrow_right@2x.png 2x" alt="次へ" /></a>
    <div class="swiper-pagination swiper-pagination-clickable swiper-pagination-bullets"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import Swiper from 'swiper/bundle'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
  },
  props: [
    'width'
  ],
  data () {
    return {
      swiper: null
    }
  },
  methods: {
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    smallLogo (path) {
      if (!path) return ''
      const smallPath = path.replace('.jpg', '_top.jpg')
      return smallPath
    },
    cutText (text) {
      if (!text) return
      const str = text.substring(0, 100)
      if (str.length === text.length) return text
      return text.substring(0, 100) + '...'
    },
    initSwiper () {
      // swiper初期設定
      this.swiper = new Swiper('.swiper-top-container', {
        slidesPerView: 2,
        spaceBetween: 10,
        shortSwipes: true,
        loop: true,
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          640: {
            slidesPerView: 3,
            spaceBetween: 10
          }
        }
      })
      // 開始位置をランダムに変更
      const start = Math.floor(Math.random() * this.specialExhibitions.length)
      this.swiper.slideTo(start, 0, false)
      this.swiper.autoplay.start()
    }
  },
  computed: {
    ...mapGetters([
      'specialExhibitions',
      'specialExhibitionsIndexById',
      'specialExhibitionById',
      'tsvLoadCompleteFlag'
    ]),
    slideStyles () {
      // return `left: ${this.virtualData.offset}px`
      return null
    }
  },
  created () {
  },
  mounted () {
    if (this.tsvLoadCompleteFlag) {
      this.initSwiper()
    }
    // vuexへの読み込み状態を監視し、読み込まれたら表示を更新する
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'setTsvCompleteFlag') {
        if (!this.tsvLoadCompleteFlag) return

        this.initSwiper()
      }
    })
  },
  watch: {
  }
}
</script>

<style scoped>
@import '~swiper/swiper-bundle.css';
.spBox {
  display: flex;
  justify-content: center;
  position: relative;
  padding: 0px 2px;
}

.descriptionText {
  overflow: hidden;
  text-overflow: ellipsis;
  padding-bottom: 48px;
}
.swiper-container {
  width: 100%;
  /* margin: 0px 46px; */
}
.swiper-button-next {
  position: absolute;
  top: 48px;
  right: 0px;
}
.swiper-button-prev {
  position: absolute;
  top: 48px;
  left: 0px;
}
.swiper-pagination {
  position: absolute;
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 120px;
  bottom: -16px;
}
</style>
